/**
 * Handles update of text or img when radios and checkboxes is clikced
 * @module giftCertUpdate
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'giftCertUpdate';
export const DEFAULTS = {
  gfcImgContainer: '',
  gfcContainer: '',
};

const radioGroup = ($el) => {
  const groupName = $el.find('input').attr('name');
  return $(`input[type="radio"][name="${groupName}"]`);
};

/**
 * Replaces text on targeted element.
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const updateText = ($selectedInput, opts) => {
  const textContainer = $(opts.gfcContainer);
  const textToUpdate = $selectedInput.data('gfc-value');
  textContainer.html(textToUpdate);
};

/**
 * Replaces image on targeted element.
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const updateImg = ($selectedInput, opts) => {
  const imgContainer = $(opts.gfcImgContainer);
  const imgToUpdate = $selectedInput.data('gfc-img');
  imgContainer.attr('src', imgToUpdate);
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, opts) => {
  const $radioGroup = radioGroup($el);
  $radioGroup.on('change', function() {
    if(this.checked) {
      const $selectedInput = $(this);
      updateText($selectedInput, opts);
      updateImg($selectedInput, opts);
    }
  });
};

/**
 * Initializes giftCertUpdate.
 * @param {HTMLElement} el - button /element that triggers giftCertUpdate
 * @param {Object} options - Options used for wiring up the giftCertUpdate
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function giftCertUpdate(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, giftCertUpdate);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/gift-cert-update.js